import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-redirection',
  templateUrl: './redirection.component.html',
  styleUrls: ['./redirection.component.scss'],
})
export class RedirectionComponent {
  constructor(private readonly route: ActivatedRoute) {}
  ngOnInit() {
    console.log(
      'this.route.snapshot?.queryParamMap',
      this.route.snapshot?.queryParamMap,
    );
    const infoString = this.route.snapshot.queryParamMap.get('info');
    const statusParam = this.route.snapshot.queryParamMap.get('status');
    const status = statusParam === 'true';
    console.log('TikTok Status:', status);
    if (infoString && status === true) {
      try {
        const decoded = decodeURIComponent(infoString);
        const tiktok = JSON.parse(decoded);
        console.log('TikTok data-->', JSON.stringify(tiktok));
        localStorage.setItem('tiktok', JSON.stringify(tiktok));
        window.close();
      } catch (e) {
        console.error('Error decoding info:', e);
        window.close();
      }
    } else {
      window.close();
    }
  }
}
